const {
  validators,
  genericValidators,
  validateEmail,
  validateMobileNumber,
  isInputValueValid,
} = require("./components/app/validators");

const {
  handleKeydown,
  removeMfaSessions,
} = require("./components/app/generalFunctions");

export var PayMaya = PayMaya || {};

const BACKSPACE = 8;
const TAB = 9;
const DELETE = 46;

const ERROR_MESSAGE_CHARACTER =
  "Letters, dashes, periods, and apostrophes only.";
const ERROR_MESSAGE_LENGTH = "Name cannot be longer than 50 characters.";
const ERROR_MESSAGE_PASSWORD_NOT_MET = "Password requirements not met!";
const ERROR_MESSAGE_BLACKLISTED_PASSWORD =
  "The password you entered is not allowed. Please enter a different password.";
const ERROR_MESSAGE_INVALID_MOBILE = "Mobile number format is invalid.";

const APPROVAL_GENERIC_ERROR = "MFA_PUSH_ERROR";

const IDENTITY_VALUE_SELECTOR = "#identityValue";
const RECAPTCHA_VALUE_SELECTOR = "#recaptcha-field";

const fadeInAnimationClass = "info-fade-in-transition";

export const mfaMaxPushNotifDialog = $("#mfa-max-push-notif-dialog");

let blinkingInterval = 0;
let isCursorShown = true;
let activeOTPInput = 1;

const INPUT_ERROR_CLASSES = {
  FIRST_NAME_ERROR: "add-firstname-error",
  LAST_NAME_ERROR: "add-lastname-error",
  BACKUP_EMAIL_ERROR: "add-backup-email-error",
  BACKUP_MOBILE_ERROR: "add-backup-mobile-number",
  PASSWORD_INVALID: "passwordInvalid",
};

PayMaya.fsMainFunction = function () {};

PayMaya.validatePassword = function (e) {
  var valid = true;
  var currentPassword = $(e).val();
  $.each(validators, function (requirement) {
    if (validators[requirement].validate(currentPassword) === false) {
      valid = validators[requirement].validate(currentPassword);
    }

    PayMaya.markRuleValidorInvalid(
      requirement,
      validators[requirement].validate(currentPassword)
    );
  });
  return valid;
};

PayMaya.checkPasswordsMatch = function (passwordEl, passwordConfirmEl) {
  const password = $(passwordEl).val();
  const passwordConfirm = $(passwordConfirmEl).val();

  const passwordNotEmpty = password.length > 0;
  if (passwordNotEmpty && password === passwordConfirm) {
    PayMaya.markRuleValidorInvalid("match", true);
    return true;
  } else {
    PayMaya.markRuleValidorInvalid("match", false);
    return false;
  }
};

PayMaya.validateName = function (e) {
  const currentPassword = $(e).val();

  return genericValidators.special.validate(currentPassword);
};

PayMaya.validateNameLength = function (e) {
  return $(e).val().length <= 50;
};

PayMaya.markRuleValidorInvalid = function (ruleName, validty) {
  var element = $(`.validation > .${ruleName}`);
  if (validty) {
    element.addClass("is-valid");
    element.removeClass("is-invalid");
  } else {
    element.removeClass("is-valid");
    element.addClass("is-invalid");
  }
};

PayMaya.validateBackUpEmail = function (e) {
  const backUpEmail = $(e).val();
  if (backUpEmail === "") {
    return true;
  } else {
    return validateEmail.special.validate(backUpEmail);
  }
};

PayMaya.validateMobileNumber = function (e) {
  const backupMobileNumber = $(e).val();
  return validateMobileNumber.special.validate(backupMobileNumber);
};

PayMaya.viewPassword = function (showPasswordSpan) {
  var passwordField = $(showPasswordSpan).prev();
  const eyeIcon = $(showPasswordSpan).find(".show-eye-icon");

  if (passwordField.attr("type") === "password") {
    eyeIcon.removeClass("close-eye-icon");
    eyeIcon.addClass("open-eye-icon");
    $(passwordField).attr("type", "text");
  } else {
    eyeIcon.removeClass("open-eye-icon");
    eyeIcon.addClass("close-eye-icon");
    $(passwordField).attr("type", "password");
  }
};

export function validateFirstName(firstNameEl, labelFirstname, errorFirstname) {
  let hasError = false;
  if (firstNameEl.length && !PayMaya.validateName(firstNameEl)) {
    changeInputErrorClass(
      INPUT_ERROR_CLASSES.FIRST_NAME_ERROR,
      ERROR_MESSAGE_CHARACTER,
      labelFirstname,
      errorFirstname
    );
    hasError = true;
  }

  if (firstNameEl.length && !PayMaya.validateNameLength(firstNameEl)) {
    changeInputErrorClass(
      INPUT_ERROR_CLASSES.FIRST_NAME_ERROR,
      ERROR_MESSAGE_LENGTH,
      labelFirstname,
      errorFirstname
    );
    hasError = true;
  }

  return hasError;
}

export function validateLastName(lastNameEl, labelLastname, errorLastname) {
  let hasError = false;
  if (lastNameEl.length && !PayMaya.validateName(lastNameEl)) {
    changeInputErrorClass(
      INPUT_ERROR_CLASSES.LAST_NAME_ERROR,
      ERROR_MESSAGE_CHARACTER,
      labelLastname,
      errorLastname
    );
    hasError = true;
  }

  if (lastNameEl.length && !PayMaya.validateNameLength(lastNameEl)) {
    changeInputErrorClass(
      INPUT_ERROR_CLASSES.LAST_NAME_ERROR,
      ERROR_MESSAGE_LENGTH,
      labelLastname,
      errorLastname
    );
    hasError = true;
  }

  return hasError;
}

export function validateBackupEmail(
  backupEmailEl,
  labelBackupEmail,
  errorBackupEmail
) {
  let hasError = false;
  if (
    backupEmailEl.length !== 0 &&
    (backupEmailEl.val().length > 100 ||
      !PayMaya.validateBackUpEmail(backupEmailEl))
  ) {
    changeInputErrorClass(
      INPUT_ERROR_CLASSES.BACKUP_EMAIL_ERROR,
      "",
      labelBackupEmail,
      errorBackupEmail
    );
    hasError = true;
  }

  return hasError;
}

export function validateBackupMIN(
  backupMobileNumberEl,
  labelBackupNumber,
  errorBackupNumber
) {
  let hasError = false;

  if (
    backupMobileNumberEl.length !== 0 &&
    !PayMaya.validateMobileNumber(backupMobileNumberEl)
  ) {
    changeInputErrorClass(
      INPUT_ERROR_CLASSES.BACKUP_MOBILE_ERROR,
      "",
      labelBackupNumber,
      errorBackupNumber
    );
    hasError = true;
  }

  return hasError;
}

export function changeInputErrorClass(method, errorMessage, labelEl, errorEl) {
  if (
    method === INPUT_ERROR_CLASSES.FIRST_NAME_ERROR ||
    method === INPUT_ERROR_CLASSES.LAST_NAME_ERROR
  ) {
    labelEl.addClass("error");
    errorEl.css("display", "flex");
    errorEl.children("div").first().text(errorMessage);
  } else if (method === INPUT_ERROR_CLASSES.PASSWORD_INVALID) {
    $(".alert").html("").hide();
    errorEl.children("div").first().text(errorMessage);
    errorEl.css("display", "flex");
    labelEl.addClass("error");
  } else if (
    method === INPUT_ERROR_CLASSES.BACKUP_EMAIL_ERROR ||
    method === INPUT_ERROR_CLASSES.BACKUP_MOBILE_ERROR
  ) {
    errorEl.css("display", "flex");
    labelEl.addClass("error");
  }
}

export function initializeRegistrationValidation() {
  const firstNameEl = $("#firstName");
  const lastNameEl = $("#lastName");
  const backupEmailEl = $("#backupIdentity-email");
  const backupMobileNumberEl = $("#backupIdentity");
  const passwordEl = $("#password-register");

  const labelPassword = $("#label-password");
  const labelFirstname = $("#label-firstname");
  const labelLastname = $("#label-lastname");
  const labelBackupEmail = $("#label-backup-email");
  const labelBackupNumber = $("#label-backup-number");

  const errorFirstname = $("#firstname-error-message");
  const errorLastname = $("#lastname-error-message");
  const errorPassword = $("#password-error-message");
  const errorBackupEmail = $("#backup-email-error-message");
  const errorBackupNumber = $("#backup-number-error-message");

  const registerForm = $("#form-create-account-register");
  if (registerForm) {
    let hasError = false;

    passwordEl.on("keyup", function () {
      PayMaya.validatePassword(this);
    });

    registerForm.on("submit", function (e) {
      e.preventDefault();
      hasError = false;
      removeFieldErrors();

      const validPassword = PayMaya.validatePassword(passwordEl);
      const validateFirstNameHasError = validateFirstName(
        firstNameEl,
        labelFirstname,
        errorFirstname
      );
      const validateLastNameHasError = validateLastName(
        lastNameEl,
        labelLastname,
        errorLastname
      );
      const validateBackupEmailHasError = validateBackupEmail(
        backupEmailEl,
        labelBackupEmail,
        errorBackupEmail
      );
      const validateBackupMINHasError = validateBackupMIN(
        backupMobileNumberEl,
        labelBackupNumber,
        errorBackupNumber
      );

      if (
        validateFirstNameHasError ||
        validateLastNameHasError ||
        validateBackupEmailHasError ||
        validateBackupMINHasError
      ) {
        hasError = true;
      }

      if (validPassword && checkBlacklistedPassword(passwordEl.val())) {
        changeInputErrorClass(
          INPUT_ERROR_CLASSES.PASSWORD_INVALID,
          ERROR_MESSAGE_BLACKLISTED_PASSWORD,
          labelPassword,
          errorPassword
        );
        hasError = true;
      } else if (!validPassword) {
        changeInputErrorClass(
          INPUT_ERROR_CLASSES.PASSWORD_INVALID,
          ERROR_MESSAGE_PASSWORD_NOT_MET,
          labelPassword,
          errorPassword
        );
        hasError = true;
      }

      if (!hasError) {
        this.submit();
      }
    });

    function checkBlacklistedPassword(password) {
      const blacklistedPassword = [
        "password",
        "password1",
        "123456789",
        "12345678",
        "sunshine",
        "iloveyou",
        "qwerty123",
        "basketball",
        "!@#$%^&*",
        "aa123456",
      ];

      return $.inArray(password, blacklistedPassword) !== -1;
    }

    function removeFieldErrors() {
      removeErrorFirstname();
      removeErrorLastname();
      removeErrorBackup();
      removeErrorPassword();
    }

    function removeErrorFirstname() {
      labelFirstname.removeClass("error");
      errorFirstname.css("display", "none");
    }

    function removeErrorLastname() {
      labelLastname.removeClass("error");
      errorLastname.css("display", "none");
    }

    function removeErrorBackup() {
      labelBackupEmail.removeClass("error");
      errorBackupEmail.css("display", "none");
      labelBackupNumber.removeClass("error");
      errorBackupNumber.css("display", "none");
    }

    function removeErrorPassword() {
      labelPassword.removeClass("error");
      errorPassword.css("display", "none");
    }
  }
}

export function initializeSetNewPasswordValidation() {
  const setNewPasswordForm = $(".form-new-password");
  const passwordConfirmField = $("#password-confirm");
  if (setNewPasswordForm) {
    $("#password").on("input", function () {
      PayMaya.validatePassword(this);

      var passwordConfirmEl = passwordConfirmField;
      checkAndEnablePasswordsEqual(this, passwordConfirmEl);
    });

    passwordConfirmField.on("input", function () {
      var passwordEl = $("#password");
      checkAndEnablePasswordsEqual(passwordEl, this);
    });

    $(".form-new-password").on("submit", function (e) {
      const errorPassword = $("#new-password-error-message .error-password");
      const errorMessageContainer = $("#new-password-error-message");
      const errorPasswordField = $(".password-field");
      const submitNewPassword = $("#submit-new");

      errorPasswordField.removeClass("error");
      submitNewPassword.attr("disabled", "true");
      e.preventDefault();

      var passwordEl = $("#password");
      var passwordConfirmEl = passwordConfirmField;

      const validPassword = PayMaya.validatePassword(passwordEl);
      const passwordsMatch = PayMaya.checkPasswordsMatch(
        passwordEl,
        passwordConfirmEl
      );
      if (validPassword && passwordsMatch) {
        errorPassword.html("");
        errorMessageContainer.css("display", "none");

        this.submit();
      } else {
        errorPassword.html("Password requirements not met!");
        errorMessageContainer.css("display", "flex");
        errorPasswordField.addClass("error");
        submitNewPassword.removeAttr("disabled");
      }
    });
  }
}

export function initializeForgotPassword() {
  const $username = $(IDENTITY_VALUE_SELECTOR);
  const $recaptcha = $(RECAPTCHA_VALUE_SELECTOR)

  const $forgotPasswordIdentityValue = $(
    "#password-submit-identity-form #identityValue"
  );

  const $forgotPasswordRecaptchaValue = $(
    "#password-submit-identity-form #recaptcha-field"
  );

  const $forgotPasswordSubmit = $(
    "#password-submit-identity-form button[type=submit]"
  );

  if ($username && $recaptcha) {
    $username.on("blur", function () {
      const currentValue = $username.val() || "";
      $username.val(currentValue.trim());
    });

    const checkIdentityValue = function () {
      const currentValue = $forgotPasswordIdentityValue.val() || "";
      const recaptchaValue = $forgotPasswordRecaptchaValue.val() || "";
      if (currentValue.trim().length > 0 && recaptchaValue.trim().length > 0) {
        $forgotPasswordSubmit.removeAttr("disabled");
      } else {
        $forgotPasswordSubmit.attr("disabled", true);
      }
    };

    $forgotPasswordIdentityValue.on("paste", checkIdentityValue);
    $forgotPasswordIdentityValue.on("input", checkIdentityValue);
    $forgotPasswordRecaptchaValue.on("change", checkIdentityValue);
  }
}

export function initializeMdcTextFieldPlaceholderLabel() {
  $(".mdc-text-field__input").on("input", function (el) {
    const e = $(el.target);
    if (e.val() === "") {
      e.css("margin-top", "10px");
    } else {
      e.css("margin-top", "unset");
    }
  });
}

export function initializeReferralForm() {
  const referralForm = $("#referral-form");
  //check if invite code has value
  if (referralForm) {
    $("#referralCode").keyup(function () {
      if ($(this).val().trim() === "") {
        $("#referral-button").prop("disabled", true);
      } else {
        $("#referral-button").prop("disabled", false);
      }
    });
  }
}

export function initializeLoginButtonAccess($btnLogin) {
  const $loginForm = $(".form-login-main");
  const $pushApprovalForm = $(".push-approval-form");
  if ($loginForm.length === 0) {
    return;
  }

  const $identityValueLabel = $("#label-identity");
  const $passwordLabel = $("#label-password");

  const $identityValue = $("#identityValue");
  const $pushApprovalInfoContainer = $(".push-approval-info-container");

  const $inlineErrors = $(".login-input-inline-error");
  const $identityValueError = $("#identity-value-error");
  const $identityValueErrorText = $("#identity-value-error .error-text");
  const $alert = $(".alert-container");

  const $textField = $("input");
  $textField.on("input", function () {
    let isValid = true;
    $textField.filter("[required]:visible").each(function () {
      if ($.trim($(this).val()) === "") {
        isValid = false;
      }
    });

    $btnLogin.prop("disabled", !isValid);
  });

  $(".mobile-only-login").on("submit", function (e) {
    e.preventDefault();
    $alert.css("display", "none");
    $inlineErrors.css("display", "none");
    $identityValueErrorText.html("");

    $passwordLabel.removeClass("error");
    $identityValueLabel.removeClass("error");
    $btnLogin.attr("disabled", true);

    const $username = $(IDENTITY_VALUE_SELECTOR);
    if (PayMaya.validateMobileNumber($username)) {
      this.submit();
    } else {
      $identityValueError.css("display", "flex");
      $identityValueErrorText.html(ERROR_MESSAGE_INVALID_MOBILE);
      $identityValueLabel.addClass("error");
      clearLoginInput($identityValueLabel);
      clearLoginInput($passwordLabel);
    }
  });

  $(".push-approval-form").on("submit", function (e) {
    e.preventDefault();

    const $identiyMobileNumber = $(IDENTITY_VALUE_SELECTOR);
    if (PayMaya.validateMobileNumber($identiyMobileNumber)) {
      this.submit();
      $btnLogin.prop("disabled", true);
      removeMfaSessions();
    } else {
      $identityValueError.css("display", "flex");
      $identityValueErrorText.html(ERROR_MESSAGE_INVALID_MOBILE);
      $identityValueLabel.addClass("error");
      $btnLogin.prop("disabled", true);
      clearLoginInput($identityValueLabel);

      window.dataLayer.push({
        event: APPROVAL_GENERIC_ERROR,
        message: ERROR_MESSAGE_INVALID_MOBILE,
      });
    }
  });

  if ($pushApprovalForm.length !== 0 && $identityValue.val() !== "") {
    $btnLogin.prop("disabled", false);
    $pushApprovalInfoContainer.addClass(fadeInAnimationClass);
  }
}

export function clearLoginInput($element) {
  $element.find("input").blur().val("");
  //Using blur() on input element directly doesn't work. Removing the class that "floats"
  //the input label is a workaround for this
  $element
    .find(".mdc-floating-label")
    .removeClass("mdc-floating-label--float-above");
}

export function initializeLoginStartForm() {
  const loginStartForm = $("#login-start-form");

  if (loginStartForm.length > 0) {
    const $loginStartInput = $(IDENTITY_VALUE_SELECTOR);
    const $loginStartSubmit = $("#btnLogin");
    $loginStartInput.on("blur", function () {
      const currentValue = $loginStartInput.val() || "";
      $loginStartInput.val(currentValue.trim());
    });

    $loginStartInput.on("keyup", function () {
      const currentValue = $loginStartInput.val() || "";
      if (currentValue.trim().length > 0) {
        $loginStartSubmit.removeAttr("disabled");
      } else {
        $loginStartSubmit.attr("disabled", true);
      }
    });
  }
}

$(function () {
  PayMaya.fsMainFunction();

  $(".toggle-password").on({
    click: function (e) {
      PayMaya.viewPassword(this);
      e.preventDefault();
    },
  });

  const $btnLogin = $("#btnLogin");

  initializeForgotPassword();
  initializeMdcTextFieldPlaceholderLabel();
  initializeRegistrationValidation();
  initializeReferralForm();
  initializeLoginButtonAccess($btnLogin);
  initializeLoginStartForm();
  initializeSetNewPasswordValidation();
  initializeDisableButtonOnClick();
  initializeFadeInFocusAnimation();
  initializePushApprovalIdleTimeChecker();
  initializeCloseDialog();
  initializeCheckingAutoFilledInputs($btnLogin);
});

export function checkAndEnablePasswordsEqual(newPassword, confirmNewPassword) {
  const matchResult = PayMaya.checkPasswordsMatch(
    newPassword,
    confirmNewPassword
  );
  const submitNewPassword = $("#submit-new");
  if (matchResult) {
    $("#password-valid-icon").attr("class", "checked-icon");
    submitNewPassword.removeAttr("disabled");
  } else {
    $("#password-valid-icon").attr("class", "unchecked-icon");
    submitNewPassword.attr("disabled", "true");
  }
}

export function preventOtpMouseDown(e) {
  const focusable = document.querySelector(".otp-field.focusable");
  if (focusable) {
    focusable.focus();
  }
  e.preventDefault();
}

export const addOTPFocusEventListener = (element) => {
  element.addEventListener("touchstart", preventOtpMouseDown);
  element.addEventListener("mousedown", preventOtpMouseDown);
  element.classList.remove("focusable");
};

export const removeOTPFocusEventListener = (element) => {
  element.removeEventListener("touchstart", preventOtpMouseDown);
  element.removeEventListener("mousedown", preventOtpMouseDown);
  element.classList.add("focusable");
};

function handleOtpInput(e) {
  const target = e.target;
  e.preventDefault();

  const next = document.querySelector(`input#${target.dataset.next}`);
  const otpInput = document.querySelector("#otp");
  const continueButton = document.querySelector("#continue");

  const value = target.value;
  if (target && value) {
    if (isInputValueValid(value)) {
      if (next) {
        addOTPFocusEventListener(target);
        removeOTPFocusEventListener(next);
        next.focus();
        activeOTPInput++;
      } else {
        checkOTPInput(otpInput, continueButton);
      }
      target.value = value.slice(0, 1);
      return true;
    } else if (next && !isNaN(value.trim()) && value.trim().length > 1) {
      e.clipboardData = {
        getData: () => value.trim(),
      };
      handleOtpPaste(e);
      target.value = value.slice(0, 1);
      return true;
    }
  }

  if (!next && !isNaN(value.trim())) {
    target.value = value.slice(0, 1);
    checkOTPInput(otpInput, continueButton);
  } else {
    target.value = "";
  }
  return false;
}

function handleOtpPaste(e) {
  const otpInput = document.querySelector("#otp");
  const continueButton = document.querySelector("#continue");

  e.preventDefault();
  const pastedData = e.clipboardData
    .getData("text/plain")
    .slice(0, 6 - activeOTPInput + 1);

  if (!isNaN(pastedData)) {
    fillOTPFields(pastedData.split(""));
    checkOTPInput(otpInput, continueButton);
  }
}

function fillOTPFields(otpData) {
  [].forEach.call(
    document.querySelectorAll(".otp-field"),
    (el, index, _fields) => {
      if (index + 1 >= activeOTPInput && otpData.length > 0) {
        const otpCharacter = otpData.shift();
        if (!isNaN(otpCharacter)) {
          el.value = otpCharacter;
          removeOTPFocusEventListener(el);
          el.focus();
          if (activeOTPInput < 6) {
            activeOTPInput++;
          }

          const prev = document.querySelector(`input#${el.dataset.previous}`);
          if (prev) {
            addOTPFocusEventListener(prev);
          }
        }
      }
    }
  );
}

function checkOTPInput(otpInput, continueButton) {
  const otpFieldsContainer = document.querySelector(".otp-fields");
  let otpValue = "";
  for (let i = 0; i < otpFieldsContainer.children.length; i++) {
    const inputChild = otpFieldsContainer.children[i];
    const tagName = inputChild.tagName;
    if (tagName === "INPUT") {
      otpValue += inputChild.value;
    }
  }

  if (!isNaN(otpValue) && otpValue.length === 6) {
    setOTPValue(otpInput, otpValue);
    continueButton.removeAttribute("disabled");
  } else {
    setOTPValue(otpInput, "");
  }
}

export function handleOtpKeyup(e) {
  const target = e.target;
  const prev = document.querySelector(`input#${target.dataset.previous}`);
  const continueButton = document.querySelector("#continue");
  const otpInput = document.querySelector("#otp");

  if (
    e.keyCode === BACKSPACE ||
    e.key === "Backspace" ||
    e.keyCode === DELETE ||
    e.key === "Delete"
  ) {
    if (prev) {
      if (target.value === "") {
        prev.value = "";
        addOTPFocusEventListener(target);
        removeOTPFocusEventListener(prev);
        prev.focus();
        activeOTPInput--;
      } else {
        target.value = "";
        target.focus();
      }

      continueButton.setAttribute("disabled", "true");
      setOTPValue(otpInput, "");
    } else {
      target.value = "";
    }
  } else {
    e.preventDefault();
  }
}

export function handleOtpFocus(e) {
  const target = e.target;
  target.setAttribute("placeholder", "|");
  if (target.value && target.value.length > 0) {
    target.setSelectionRange(1, 1);
  }

  blinkingInterval = setInterval(() => {
    if (isCursorShown) {
      target.setAttribute("placeholder", "");
      isCursorShown = false;
    } else {
      target.setAttribute("placeholder", "|");
      isCursorShown = true;
    }
  }, 500);
}

export function handleOtpBlur(e) {
  clearInterval(blinkingInterval);
  const target = e.target;
  target.setAttribute("placeholder", "—");

  if (target.value !== "") {
    const next = document.querySelector(`input#${target.dataset.next}`);
    if (next) {
      addOTPFocusEventListener(target);
      removeOTPFocusEventListener(next);
    } else {
      removeOTPFocusEventListener(target);
    }
  }
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const formOtp = document.querySelector(".form-otp");
    const continueButton = document.querySelector("#continue");

    [].forEach.call(
      document.querySelectorAll("input.otp-field"),
      (inputChild, index) => {
        const tagName = inputChild.tagName;
        if (tagName === "INPUT") {
          inputChild.addEventListener("input", handleOtpInput);
          inputChild.addEventListener("paste", handleOtpPaste);
          inputChild.addEventListener("keyup", handleOtpKeyup);
          inputChild.addEventListener("focus", handleOtpFocus);
          inputChild.addEventListener("blur", handleOtpBlur);
          inputChild.addEventListener("keydown", handleKeydown);

          if (index !== 0) {
            inputChild.addEventListener("mousedown", preventOtpMouseDown);
          } else {
            inputChild.classList.add("focusable");
            inputChild.focus();
          }
        }
      }
    );

    if (formOtp) {
      formOtp.addEventListener("submit", () => {
        activeOTPInput = 1;
        continueButton.setAttribute("disabled", "true");
      });
    }
  },
  false
);

export function setOTPValue(otpInput, otpValue) {
  if (otpInput) {
    otpInput.value = otpValue;
  }
}

function initializeDisableButtonOnClick() {
  const authorizedForm = $(".form-authorize");
  const permissionButtons = $(".forgot-password-form .mdc-button");

  if (authorizedForm.length !== 0) {
    permissionButtons.on("click", function () {
      authorizedForm.submit();
      permissionButtons.attr("disabled", true);
    });
  }
}

export function initializeFadeInFocusAnimation() {
  const pushApprovalField = $(".push-approval-input");
  const pushApprovalInfoContainer = $(".push-approval-info-container");

  if (pushApprovalField.length !== 0) {
    pushApprovalField.on("focus", function () {
      if (!pushApprovalInfoContainer.hasClass(fadeInAnimationClass)) {
        pushApprovalInfoContainer.addClass(fadeInAnimationClass);
      }
    });
  }
}

export function initializePushApprovalIdleTimeChecker() {
  const idleContainerClass = $(".idle-time-container");
  const remainingTimeContainer = $("#time-left");
  const inactiveTimeContainer = $("#inactivity-time");
  const redirectForm = $("#redirect-push-approval");

  let idleTimeout;
  let remainingTime;

  if (
    redirectForm.length !== 0 &&
    (mfaMaxPushNotifDialog.css("display") === "none" ||
      mfaMaxPushNotifDialog.length === 0)
  ) {
    const countdownInSeconds = window.mfaTimerConfig.expiryCountdown;
    const idleTimeInSeconds = window.mfaTimerConfig.idleTimeCountdown;
    const idleTimeInSecondsToMillisecond = idleTimeInSeconds * 1000;
    const idleTimeInSecondsToMinutes = Math.floor(idleTimeInSeconds / 60);
    const timeUnit = idleTimeInSecondsToMinutes === 1 ? "minute" : "minutes";
    inactiveTimeContainer.text(`${idleTimeInSecondsToMinutes} ${timeUnit}`);

    $(window).on(
      "load resize mousemove mousedown click touchstart touchend touchmove scroll resize keypress wheel",
      function () {
        resetTimer(countdownInSeconds, idleTimeInSecondsToMillisecond);
      }
    );
  } else {
    $(window).off(
      "load resize mousemove mousedown click touchstart touchend touchmove scroll resize keypress wheel"
    );
  }

  function resetTimer(countdownInSeconds, idleTimeInSecondsToMillisecond) {
    clearTimeout(idleTimeout);
    clearInterval(remainingTime);
    remainingTimeContainer.text(`${countdownInSeconds} seconds`);
    idleContainerClass.css("display", "none");
    idleTimeout = setTimeout(stopIdleTime, idleTimeInSecondsToMillisecond);
  }

  function stopIdleTime() {
    idleContainerClass.css("display", "block");
    let timeLeft = window.mfaTimerConfig.expiryCountdown;
    remainingTime = setInterval(function () {
      if (timeLeft <= 0) {
        clearInterval(remainingTime);
        redirectForm.submit();
      } else {
        const timeUnit = timeLeft === 1 ? "second" : "seconds";
        remainingTimeContainer.text(`${timeLeft} ${timeUnit}`);
      }
      timeLeft--;
    }, 1000);
  }
}

export function initializeCloseDialog() {
  const dfDialog = $(".df-block-dialog");
  const closeBtn = $(".close-dialog-btn");

  if (dfDialog.length !== 0) {
    closeBtn.on("click", function () {
      dfDialog.css("display", "none");
    });
  }
}

//Function to handle overlapping of labels in chrome browser
function initializeCheckingAutoFilledInputs(button) {
  const passwordForm = $("#password");
  let countCheck = 5,
    autoFillChecker;
  if (passwordForm.length > 0 && countCheck !== 0) {
    autoFillChecker = setInterval(function () {
      countCheck--;
      document
        .querySelectorAll(".mdc-text-field__input:-webkit-autofill")
        .forEach((el) => {
          const textField = el.parentNode;
          const label = textField.querySelector(".mdc-floating-label");
          if (label) {
            label.classList.add("mdc-floating-label--float-above");
            button.prop("disabled", false);
            clearInterval(autoFillChecker);
          }
        });

      if (countCheck === 0) {
        clearInterval(autoFillChecker);
      }
    }, 500);
  }
}
